import { AvgVideosReviewed } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/AvgVideosReviewed/AvgVideosReviewed";
import { BCBAResponseToRBTQuestion } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/BCBAResponseToRBTQuestion/BCBAResponseToRBTQuestion";
import { CommentDistributionRawData } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/CommentDistribution/CommentDistributionRawData";
import { ReviewCompletionTime } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/ReviewCompletionTime/ReviewCompletionTime";
import { GraphRawDataDialog } from "@pages/VideoAnalytics/components/GraphRawDataDialog";
import { BCBA_ANALYTICS_TITLES } from "@pages/VideoAnalytics/helpers";

interface GraphDialogsProps {
  isAvgVideosReviewedOpen: boolean;
  setIsAvgVideosReviewedOpen: (open: boolean) => void;

  isPercentageVideosReviewedOpen: boolean;
  setIsPercentageVideosReviewedOpen: (open: boolean) => void;

  isResponseTimeToRBTQuestionOpen: boolean;
  setIsResponseTimeToRBTQuestionOpen: (open: boolean) => void;

  isResponseRateToRBTQuestionOpen: boolean;
  setIsResponseRateToRBTQuestionOpen: (open: boolean) => void;

  isCommentDistributionOpen: boolean;
  setIsCommentDistributionOpen: (open: boolean) => void;

  isCommentOpen: boolean;
  setIsCommentOpen: (open: boolean) => void;

  isReviewCompletionDialogOpen: boolean;
  setIsReviewCompletionDialogOpen: (open: boolean) => void;
}
export const GraphDialogs: React.FC<GraphDialogsProps> = ({
  isAvgVideosReviewedOpen,
  setIsAvgVideosReviewedOpen,
  isPercentageVideosReviewedOpen,
  setIsPercentageVideosReviewedOpen,
  isResponseTimeToRBTQuestionOpen,
  setIsResponseTimeToRBTQuestionOpen,
  isResponseRateToRBTQuestionOpen,
  setIsResponseRateToRBTQuestionOpen,
  isCommentDistributionOpen,
  setIsCommentDistributionOpen,
  isCommentOpen,
  setIsCommentOpen,
  isReviewCompletionDialogOpen,
  setIsReviewCompletionDialogOpen,
}) => {
  return (
    <div>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.AVG_VIDEOS_REVIEWED_PER_BCBA}
        open={isAvgVideosReviewedOpen}
        setOpen={setIsAvgVideosReviewedOpen}
      >
        <AvgVideosReviewed avgVideosReviewed={true} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.PERCENTAGE_VIDEOS_REVIEWED}
        open={isPercentageVideosReviewedOpen}
        setOpen={setIsPercentageVideosReviewedOpen}
      >
        <AvgVideosReviewed avgVideosReviewed={false} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.AVG_RESPONSE_TIME_TO_RBT}
        open={isResponseTimeToRBTQuestionOpen}
        setOpen={setIsResponseTimeToRBTQuestionOpen}
      >
        <BCBAResponseToRBTQuestion isResponseRate={false} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.AVG_RESPONSE_RATE_TO_RBT}
        open={isResponseRateToRBTQuestionOpen}
        setOpen={setIsResponseRateToRBTQuestionOpen}
      >
        <BCBAResponseToRBTQuestion isResponseRate={true} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.AVG_COMMENTS_LEFT_PER_VIDEO}
        open={isCommentOpen}
        setOpen={setIsCommentOpen}
      >
        <CommentDistributionRawData isCommentDistributionWithCommentType={false} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.BREAKDOWN_OF_COMMENTS_LEFT}
        open={isCommentDistributionOpen}
        setOpen={setIsCommentDistributionOpen}
      >
        <CommentDistributionRawData isCommentDistributionWithCommentType={true} />
      </GraphRawDataDialog>
      <GraphRawDataDialog
        title={BCBA_ANALYTICS_TITLES.AVG_REVIEW_COMPLETION_TIME}
        open={isReviewCompletionDialogOpen}
        setOpen={setIsReviewCompletionDialogOpen}
      >
        <ReviewCompletionTime />
      </GraphRawDataDialog>
    </div>
  );
};
